import { useMemo } from "react";
import { CrewMember } from "./CrewMember";
import { ICrewMember } from "src/redux/reducers/CrewScheduleReducer";
import { useDispatch, useSelector } from "react-redux";
import { useDrop, DropTargetMonitor } from "react-dnd";
import { IFullPairingPosition, OpenFlyingStatusType } from "@vmosolutions/oc-interfaces";
import { ICrewDraggable } from "../PairingEditorWindow/CrewMember";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { updatePairingEditor } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";

interface ICrewMemberDropTargetProps {
  crewMember: ICrewMember;
  positionStr?: string;
  isOnPairing?: boolean;
  positionIndex?: number;
  disableMouseEvents?: boolean;
  openFlyingDisplayIndex?: number;
  windowId?: string;
}

export const CrewMemberDropTarget = (props: ICrewMemberDropTargetProps): JSX.Element => {
  const { crewMember, positionStr, positionIndex, windowId } = props;
  const dispatch = useDispatch();
  const storedPairing = useSelector((state: IRootState) => state.crewSchedule.pairingEditors[windowId]);
  const pairingPositions: IFullPairingPosition[] = useMemo(
    () => storedPairing?.positions ?? [],
    [storedPairing?.positions]
  );
  const pairingPosition: IFullPairingPosition | null = useMemo(() => {
    return pairingPositions?.length > 0 && positionIndex !== null ? pairingPositions[positionIndex] : null;
  }, [pairingPositions, positionIndex]);

  const [, drop] = useDrop({
    accept: ["CREW_REASSIGN"],
    drop(i: any, monitor: DropTargetMonitor) {
      const item: ICrewDraggable = i;
      if (positionIndex && positionIndex < 0) {
        return;
      }
      const positions: IFullPairingPosition[] = [...pairingPositions];
      const temp = positions[positionIndex];
      const positionFulfilled = item.crewMember.crewInfo.positions.find((pos) => pos.title === positionStr);

      positions[positionIndex] = {
        crew: item.crewMember,
        position: positionFulfilled, // Reset to closed when position re-assigned
        openFlyingStatus: OpenFlyingStatusType.Closed,
      };

      positions[item.positionIndex] = temp;
      dispatch(updatePairingEditor(windowId, { positions }));
    },
    //hover(item: ICrewDraggable, monitor: DropTargetMonitor) {
    // Debug.log(item)
    //},
    canDrop(i: any, monitor: DropTargetMonitor) {
      const item: ICrewDraggable = i;
      return (
        item.crewMember._id !== crewMember._id &&
        !!item.crewMember.crewInfo.positions.find((crewPosition: any) => crewPosition.title === positionStr)
      );
    },
    collect(monitor: DropTargetMonitor) {
      return {
        isOver: monitor.isOver(),
      };
    },
  });

  return (
    <div ref={drop}>
      <CrewMember desiredPosition={pairingPosition} {...props} />
    </div>
  );
};
